// import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import store from '../../store';
import { hasMarkStateSelector } from '../../store/mark/selector';
import { MARK_STATE } from '../../store/mark/types';
const FreehandRoiTool = cornerstoneTools.FreehandRoiTool;
const { getToolState, importInternal } = cornerstoneTools;

const getNewContext = importInternal('drawing/getNewContext');
const draw = importInternal('drawing/draw');
const drawJoinedLines = importInternal('drawing/drawJoinedLines');
const drawHandles = importInternal('drawing/drawHandles');
const freehandUtils = importInternal('util/freehandUtils');
const triggerEvent = importInternal('util/triggerEvent');

let isEdit = false;
let isCreate = false;
store.subscribe(() => {
  const state = store.getState();
  const hasMarkState = hasMarkStateSelector(state);
  isCreate = !hasMarkState(MARK_STATE.ENABLED_CREATE);
  isEdit = !hasMarkState(MARK_STATE.ENABLED_EDIT);
});
export default class MarkFreehandRoiTool extends FreehandRoiTool {
  constructor(name = 'MarkFreehandRoi') {
    super({
      name,
      configuration: {
        spacing: parseInt(localStorage.getItem('freehand-spacing')) || 1,
        activeHandleRadius: 0.5,
      },
    });
  }
  handleSelectedCallback(...args) {
    if (isEdit) return super.handleSelectedCallback(...args);
    const [evt, toolData] = args;
    const { element } = evt.detail;
    const toolName = toolData.toolType || toolData.toolName;
    const modifiedEventData = {
      toolName,
      toolType: toolName, // Deprecation notice: toolType will be replaced by toolName
      element,
      measurementData: { ...toolData, active: false },
    };
    triggerEvent(
      element,
      cornerstoneTools.EVENTS.MEASUREMENT_COMPLETED,
      modifiedEventData
    );
    return preventPropagation(evt);
  }
  preMouseDownCallback(evt) {
    const eventData = evt.detail;
    const nearby = super._pointNearHandleAllTools(eventData);

    if (eventData.event.ctrlKey && !isCreate) {
      if (nearby !== undefined && nearby.handleNearby.hasBoundingBox) {
        // Ctrl + clicked textBox, do nothing but still consume event.
      } else {
        if (!nearby) {
          freehandUtils.insertOrDelete.call(this, evt, nearby);
        }
      }

      preventPropagation(evt);

      return true;
    }

    return false;
  }
  addNewMeasurement(evt) {
    if (!isCreate) return;
    const eventData = evt.detail;
    if (isEdit) {
      if (eventData.event.ctrlKey) {
        super._addPoint(eventData);
      } else {
        return false;
      }
    } else {
      super._startDrawing(evt);
      super._addPoint(eventData);
    }
  }
  renderToolData(evt) {
    const eventData = evt.detail;

    // If we have no toolState for this element, return immediately as there is nothing to do
    const toolState = getToolState(evt.currentTarget, this.name);

    if (!toolState) {
      return;
    }

    const { image, element } = eventData;
    const config = this.configuration;
    // const seriesModule = cornerstone.metaData.get(
    //   'generalSeriesModule',
    //   image.imageId
    // );
    // const modality = seriesModule ? seriesModule.modality : null;
    const context = getNewContext(eventData.canvasContext.canvas);
    // const lineWidth = cornerstoneTools.toolStyle.getToolWidth();
    const { renderDashed } = config;
    const lineDash = cornerstoneTools.getModule('globalConfiguration')
      .configuration.lineDash;

    for (let i = 0; i < toolState.data.length; i++) {
      const data = toolState.data[i];

      if (data.visible === false) {
        continue;
      }

      draw(context, context => {
        let color = cornerstoneTools.toolColors.getColorIfActive(data);
        let fillColor;

        if (data.active) {
          if (data.handles.invalidHandlePlacement) {
            color = config.invalidColor;
            fillColor = config.invalidColor;
          } else {
            color = cornerstoneTools.toolColors.getColorIfActive(data);
            fillColor = cornerstoneTools.toolColors.getFillColor();
          }
        } else {
          fillColor = cornerstoneTools.toolColors.getToolColor();
        }

        let options = { color };

        if (renderDashed) {
          options.lineDash = lineDash;
        }

        if (data.handles.points.length) {
          const points = data.handles.points;

          drawJoinedLines(context, element, points[0], points, options);

          if (data.polyBoundingBox) {
            drawJoinedLines(
              context,
              element,
              points[points.length - 1],
              [points[0]],
              options
            );
          } else {
            drawJoinedLines(
              context,
              element,
              points[points.length - 1],
              [config.mouseLocation.handles.start],
              options
            );
          }
        }

        // Draw handles

        options = {
          color,
          fill: fillColor,
        };

        if (config.alwaysShowHandles || (data.active && data.polyBoundingBox)) {
          // Render all handles
          options.handleRadius = config.activeHandleRadius;

          if (this.configuration.drawHandles) {
            drawHandles(context, eventData, data.handles.points, options);
          }
        }

        if (data.canComplete) {
          // Draw large handle at the origin if can complete drawing
          options.handleRadius = config.completeHandleRadius;
          const handle = data.handles.points[0];

          if (this.configuration.drawHandles) {
            drawHandles(context, eventData, [handle], options);
          }
        }

        if (data.active && !data.polyBoundingBox) {
          // Draw handle at origin and at mouse if actively drawing
          options.handleRadius = config.activeHandleRadius;

          if (this.configuration.drawHandles) {
            drawHandles(
              context,
              eventData,
              config.mouseLocation.handles,
              options
            );
          }

          const firstHandle = data.handles.points[0];

          if (this.configuration.drawHandles) {
            drawHandles(context, eventData, [firstHandle], options);
          }
        }

        // Update textbox stats
        if (data.invalidated === true && !data.active) {
          if (data.meanStdDev && data.meanStdDevSUV && data.area) {
            this.throttledUpdateCachedStats(image, element, data);
          } else {
            this.updateCachedStats(image, element, data);
          }
        }
      });
    }
  }
}

function preventPropagation(evt) {
  evt.stopImmediatePropagation();
  evt.stopPropagation();
  evt.preventDefault();
}
